import Swiper from 'swiper';
import scrollToElement from 'scroll-to-element';
import assetsLoader from 'assets-loader';

import './index.scss';

const SIZE_MOBILE = 767;
const SECTION_INTRO_MIN_HEIGHT = 570;

class App {
  constructor({
    rootEl,
    loaderEl,
    bgOverlayEl,
    galleryVideoWidth,
    galleryVideoHeight,
  }) {
    this.galleryVideoWidth = galleryVideoWidth;
    this.galleryVideoHeight = galleryVideoHeight;
    this.loadingValue = 0;
    this.loadedValue = 0;

    this.cacheDomEls(rootEl, loaderEl, bgOverlayEl);
    this.initGallery();
    this.bindEvents();
    // this.resizeAll();

    this.initLoader();
  }

  initLoader() {
    const isMobile = this.isMobileSize();
    const {loaderValueEl} = this.dom;

    this.animateLoadingPercent();

    const loader = assetsLoader({
      assets: [
        {
          id: 'introVideo',
          blob: true,
          url: isMobile
            ? 'assets/video/mobile/sentimental-ring.mp4'
            : 'assets/video/sentimental-ring.mp4'
        },
        { url: 'assets/i/arrow-down-icon.svg', type: 'png' },
        { url: 'assets/i/arrow-left-icon.svg', type: 'png' },
        { url: 'assets/i/arrow-right-icon.svg', type: 'png' },
        { url: 'assets/i/circle.svg', type: 'png' },
        { url: 'assets/i/close-icon.svg', type: 'png' },
        { url: 'assets/i/curve-1.svg', type: 'png' },
        { url: 'assets/i/curve-2.svg', type: 'png' },
        { url: 'assets/i/glow-1.svg', type: 'png' },
        { url: 'assets/i/glow-2.svg', type: 'png' },
        { url: 'assets/i/interactopus.svg', type: 'png' },
        { url: 'assets/i/play-icon.svg', type: 'png' },
        { url: 'assets/i/sentimental.svg', type: 'png' },
      ].concat(
        isMobile
          ? [
            'assets/i/mobile/hands-bird.png',
            'assets/i/mobile/hands-cloud.jpg',
            'assets/i/mobile/hands-flower.jpg',
            'assets/i/mobile/hands-frame.jpg',
            'assets/i/mobile/hands-heart.jpg',
            'assets/i/mobile/model.jpg',
          ]
          : [
            'assets/i/hands-bird.png',
            'assets/i/hands-cloud.jpg',
            'assets/i/hands-flower.jpg',
            'assets/i/hands-frame.jpg',
            'assets/i/hands-heart.jpg',
            'assets/i/model.jpg',
          ]
      )
    })
      .on('error', function(error) {
        console.error(error);
      })
      .on('progress', (progress) => {
        const percent = (progress * 100).toFixed();
        // loaderValueEl.innerText = percent;
        this.loadedValue = percent;
        this.animateLoadingPercent();
      })
      .on('complete', (assets) => {
        this.loadedValue = 100;
        this.animateLoadingPercent();

        setTimeout(() => {
          this.dom.loaderEl.classList.remove('is-visible');
          this.dom.rootEl.style.display = 'block';
          this.resizeAll();
          setTimeout(() => {
            this.dom.rootEl.classList.add('is-visible');
            setTimeout(() => {
              setTimeout(() => {
                const introVideoBlob = loader.get('introVideo');
                const videoEl = document.createElement('video');
                videoEl.setAttribute('playsinline', '');
                videoEl.setAttribute('webkit-playsinline', '');  // Support inline videos for iOS webviews.
                videoEl.autoplay = true;
                videoEl.loop = true;
                videoEl.muted = true;
                videoEl.className = 'AppSectionIntro-video';
                videoEl.src = window.URL.createObjectURL(introVideoBlob);
                this.dom.sectionIntroVideoContainer.appendChild(videoEl);
                setTimeout(() => {
                  this.resizeAll();
                }, 1000);
              }, this.isMobileSize() ? 2200 : 0);
            }, 0);
          }, 1500);
        }, 500)

      })
      .start();
  }

  animateLoadingPercent = () => {
    clearTimeout(this.animateLoadingPercentTimeout);
    const {loadingValue, loadedValue} = this;
    if (loadingValue >= 100) {
      this.dom.loaderValueEl.innerText = '100%';
      return;
    }
    if (loadingValue == 0 || (loadingValue < loadedValue)) {
      const incValue = Math.min(loadedValue - loadingValue, 5);
      this.loadingValue += incValue;
      this.dom.loaderValueEl.innerText = `${this.loadingValue}%`;
      this.animateLoadingPercentTimeout = setTimeout(() => {
        this.animateLoadingPercent();
      }, 100);
    }
  };

  cacheDomEls(rootEl, loaderEl, bgOverlayEl) {
    this.dom = {
      rootEl: rootEl,
      loaderEl: loaderEl,
      loaderValueEl: loaderEl.querySelector('.AppLoader-value'),
      galleryEl: rootEl.querySelector('.AppGallery .swiper-container'),
      galleryVideoEls: rootEl.querySelectorAll('.AppGallery .swiper-container iframe'),
      manRing: rootEl.querySelector('.AppSectionTry-manRingArea'),
      womanRingGlow: rootEl.querySelector('.AppSectionTry-glow'),
      sectionIntroContainerEl: rootEl.querySelector('.AppSectionIntro .AppSection-container'),
      sectionIntroVideoContainer: rootEl.querySelector('.AppSectionIntro .AppSectionIntro-videoContainer'),
      sectionIntroVideo: rootEl.querySelector('.AppSectionIntro video'),
      sectionIntroMoreButtonEl: rootEl.querySelector('.AppSectionIntro .AppSectionIntro-more'),
      sectionIntroButtonVideo: rootEl.querySelector('.AppSectionIntro .AppButton.is-video'),
      sectionAboutEl: rootEl.querySelector('.AppSectionAbout'),
      sectionGalleryEl: rootEl.querySelector('.AppSectionGallery'),
      sectionGalleryTitleEl: rootEl.querySelector('.AppSectionGallery .AppSectionTitle'),
      bgOverlayEl: bgOverlayEl,
      modalEl: bgOverlayEl.querySelector('.AppModal'),
      modalInputEl: bgOverlayEl.querySelector('.AppModal input'),
      modalSubmitEl: bgOverlayEl.querySelector('.AppModal .AppButton'),
      modalCloseEl: bgOverlayEl.querySelector('.AppModal .AppModal-closeButton'),
      modalContainerReadyEl: bgOverlayEl.querySelector('.AppModal .is-ready'),
      modalContainerSuccessEl: bgOverlayEl.querySelector('.AppModal .is-success'),
      buttonPreorderIntro: rootEl.querySelector('.AppSectionIntro .AppButton.is-preorder'),
      buttonPreorderPreorder: rootEl.querySelector('.AppSectionPreorder .AppButton.is-preorder'),
    };
  }

  initGallery() {
    this.swiper = new Swiper('.swiper-container', {
      loop: true,
      pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      paginationClickable: true,
    });
  }
  bindEvents() {
    window.addEventListener('resize', this.onResize, false);

    this.dom.manRing.addEventListener('click', this.onManRingClick, false);

    this.dom.sectionIntroMoreButtonEl.addEventListener('click', (event) => {
      event.preventDefault();
      this.trackEvenet('introMoreButton', 'click');
      this.scrollTo(this.dom.sectionAboutEl);
    }, false);

    this.dom.sectionIntroButtonVideo.addEventListener('click', (event) => {
      event.preventDefault();
      this.trackEvenet('introVideoButton', 'click');
      this.scrollTo(this.dom.sectionGalleryTitleEl);
    }, false);

    this.dom.buttonPreorderIntro.addEventListener('click', event => {
      event.preventDefault();
      this.trackEvenet('introPreorderButton', 'click');
      this.showModal();
    }, false);


    this.dom.buttonPreorderPreorder.addEventListener('click', event => {
      event.preventDefault();
      this.trackEvenet('preorderPreorderButton', 'click');
      this.showModal();
    }, false);

    this.dom.modalCloseEl.addEventListener('click', event => {
      event.preventDefault();
      this.trackEvenet('modalCloseButton', 'click');
      this.hideModal();
    }, false);

    this.dom.modalSubmitEl.addEventListener('click', event => {
      event.preventDefault();
      this.trackEvenet('modalSubmitButton', 'click');
      this.submitModal();
    }, false);

  }

  scrollTo(el) {
    scrollToElement(el, {
      offset: 0,
      duration: 1000,
    });
  }

  showModal() {
    this.dom.bgOverlayEl.classList.add('is-visible');
    setTimeout(() => {
      this.dom.modalInputEl.focus();
    }, 500);
  }

  hideModal() {
    this.dom.bgOverlayEl.classList.remove('is-visible');
  }

  submitModal() {
    this.trackEvenet('modal', 'submit', this.dom.modalInputEl.value);
    this.dom.modalEl.classList.remove('is-ready');
    this.dom.modalEl.classList.add('is-success');
  }

  trackEvenet(eventName, eventAction, value) {
    try {
      window.ga('send', 'event', {
        eventCategory: eventName,
        eventAction: eventAction,
        eventValue: value,
      });
    } catch(error) {
      console.error(error);
    }
  }

  onManRingClick = (event) => {
    event.preventDefault();
    this.toggleWomanRingGlow();
  };

  toggleWomanRingGlow() {
    const {womanRingGlow} = this.dom;
    if (womanRingGlow.classList.contains('is-animate')) {
      return;
    }
    womanRingGlow.classList.add('is-animate');
    setTimeout(() => {
      womanRingGlow.classList.remove('is-animate');
    }, 6000);
  }

  onResize = () => {
    this.resizeAll();
  };
  resizeAll() {
    const {
      galleryEl,
      galleryVideoEls,
      sectionIntroContainerEl,
    } = this.dom;

    const {
      galleryVideoWidth,
      galleryVideoHeight,
    } = this;

    const windowHeight = window.innerHeight;

    const galleryWidth = galleryEl.offsetWidth;
    const newGalleryHeight = Math.round(galleryWidth * galleryVideoHeight / galleryVideoWidth);
    galleryEl.style.height = `${newGalleryHeight}px`;

    const newSectionIntroContainerHeight = windowHeight < SECTION_INTRO_MIN_HEIGHT
      ? SECTION_INTRO_MIN_HEIGHT
      : windowHeight;
    sectionIntroContainerEl.style.height = `${newSectionIntroContainerHeight}px`;
    this.swiper.update(true);
  }

  isMobileSize() {
    return window.innerWidth <= SIZE_MOBILE;
  }
}
window.App = App;



/** WEBPACK FOOTER **
 ** ./src/client/index.js
 **/